import { render, staticRenderFns } from "./ProductDesign2Form.vue?vue&type=template&id=02220d76&"
import script from "./ProductDesign2Form.vue?vue&type=script&lang=js&"
export * from "./ProductDesign2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports